const e = {
  id: "NewYorkTake5",
  logo: !0,
  name: "Take 5",
  style: {
    colorPrimary: "#00928f"
  }
};
export {
  e as default
};
